import { lazy, Suspense, useState } from 'react';
import { MdAddReaction, MdContentCopy, MdEdit, MdForward, MdRemoveCircleOutline, MdReply, MdTranslate } from 'react-icons/md';
import { Modal } from './ui';

const EmojiPicker = lazy(() => import('emoji-picker-react'));
export const REAZIONI = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

// Tutto quello che si può fare con un messaggio, con le parole scritte accanto
// alle icone. Prima c'era una barra che compariva solo passando col mouse o
// toccando il fumetto, senza nessun indizio: «che devo cliccare?» (29/09/2026).
// Sul telefono è un foglio dal basso, sul computer una finestra al centro.
// WhatsApp lascia modificare un messaggio per 15 minuti e solo dal dispositivo
// che l'ha inviato: la voce compare per i propri messaggi di testo recenti, e se
// era partito dal telefono il server lo dice (04/10/2026).
export const MODIFICA_ENTRO_MS = 15 * 60 * 1000;
export const modificabile = (msg, adesso = Date.now()) => !!msg && msg.direction === 'outbound'
  && (!msg.message_type || msg.message_type === 'text') && !!msg.whatsapp_message_id && !!msg.body
  && adesso - new Date(msg.timestamp).getTime() < MODIFICA_ENTRO_MS;

export default function MessageMenu({ msg, onClose, attivo, onReply, onReact, onForward, onCopy, onTranslate, onEdit }) {
  const [altre, setAltre] = useState(false);
  if (!msg) return null;
  const esegui = azione => () => { onClose(); azione(); };
  const anteprima = (msg.body || '').slice(0, 90) + ((msg.body || '').length > 90 ? '…' : '');
  const voci = [
    attivo && { icona: MdReply, testo: 'Rispondi', azione: onReply },
    attivo && { icona: MdForward, testo: 'Inoltra', azione: onForward },
    attivo && onEdit && modificabile(msg) && { icona: MdEdit, testo: 'Modifica', azione: onEdit },
    msg.body && { icona: MdContentCopy, testo: 'Copia testo', azione: onCopy },
    msg.body && onTranslate && { icona: MdTranslate, testo: 'Traduci in italiano', azione: onTranslate },
    attivo && msg.reactions && Object.keys(msg.reactions).length > 0
      && { icona: MdRemoveCircleOutline, testo: 'Togli la mia reazione', azione: () => onReact('') },
  ].filter(Boolean);
  return (
    <Modal open onClose={onClose} label="Messaggio" description={anteprima || undefined} size="sm">
      <div className="overflow-y-auto px-4 py-3">
        {attivo ? (
          <div role="group" aria-label="Reagisci" className="mb-2 flex items-center justify-between gap-1">
            {REAZIONI.map(emoji => (
              <button key={emoji} type="button" aria-label={`Reagisci con ${emoji}`} onClick={esegui(() => onReact(emoji))}
                className="h-11 w-11 rounded-full text-2xl hover:bg-canvas">{emoji}</button>
            ))}
            <button type="button" aria-label="Altre emoji" aria-expanded={altre} onClick={() => setAltre(!altre)}
              className="flex h-11 w-11 items-center justify-center rounded-full text-muted hover:bg-canvas">
              <MdAddReaction size={24} aria-hidden="true" />
            </button>
          </div>
        ) : (
          <p className="mb-2 text-sm text-muted">Connessione non pronta: rispondere, reagire e inoltrare non è possibile adesso.</p>
        )}
        {altre && (
          <Suspense fallback={<p className="text-sm text-muted">Caricamento emoji…</p>}>
            <EmojiPicker onEmojiClick={dati => { onClose(); onReact(dati.emoji); }} width="100%" height={320}
              searchPlaceholder="Cerca emoji…" previewConfig={{ showPreview: false }} />
          </Suspense>
        )}
        <ul className="divide-y divide-line">
          {voci.map(({ icona: Icona, testo, azione }) => (
            <li key={testo}>
              <button type="button" onClick={esegui(azione)}
                className="flex min-h-[48px] w-full items-center gap-3 px-1 text-left text-sm text-ink hover:bg-canvas">
                <Icona size={20} aria-hidden="true" className="text-muted" /> {testo}
              </button>
            </li>
          ))}
        </ul>
      </div>
    </Modal>
  );
}
